var RenderTypes = require('../../../../constants.js').RenderTypes
export const RenderConfig = {
  // Visible to all:
  'BodyShopDeliveryAltLocationId': SetRenderType(GetAllTyped(RenderTypes.SELECTLIST2), ['bookedCustomerRenderType'], RenderTypes.FORMATTER),
  'BodyShopDeliveryTime': SetRenderType(GetAllTyped(RenderTypes.DATETIME), ['bookedCustomerRenderType'], RenderTypes.FORMATTER),
  'BodyShopLoosePartsType': SetRenderType(GetAllTyped(RenderTypes.RADIOLIST), ['bookedCustomerRenderType'], RenderTypes.FORMATTER),
  'BodyShopPickupAltLocationId': SetRenderType(GetAllTyped(RenderTypes.SELECTLIST2), ['bookedCustomerRenderType'], RenderTypes.FORMATTER),
  'BodyShopPickupTime': SetRenderType(GetAllTyped(RenderTypes.DATETIME), ['bookedCustomerRenderType'], RenderTypes.FORMATTER),
  'BodyShopPublishDate': SetRenderTypeBooked(GetBlank(), RenderTypes.FORMATTER),
  'BodyShopTransport': GetAllTyped(RenderTypes.RADIOLIST), // SetRenderType(GetAllTyped(RenderTypes.CHECKBOXLIST), ['bookedCustomerRenderType'], RenderTypes.FORMATTER),
  'BrandName': SetRenderType(GetAllTyped(RenderTypes.SELECTLIST), ['bookedCustomerRenderType'], RenderTypes.FORMATTER),
  'CarOwnerMail': SetRenderType(GetAllTyped(RenderTypes.INPUT), ['bookedCustomerRenderType'], RenderTypes.FORMATTER),
  'CarOwnerName': SetRenderType(GetAllTyped(RenderTypes.INPUT), ['bookedCustomerRenderType'], RenderTypes.FORMATTER),
  'CarOwnerLastName': SetRenderType(GetAllTyped(RenderTypes.INPUT), ['bookedCustomerRenderType'], RenderTypes.FORMATTER),
  'CarOwnerAddress': SetRenderType(GetAllTyped(RenderTypes.INPUT), ['bookedCustomerRenderType'], RenderTypes.FORMATTER),
  'CarOwnerZipCode': SetRenderType(GetAllTyped(RenderTypes.INPUT), ['bookedCustomerRenderType'], RenderTypes.FORMATTER),
  'CarOwnerCity': SetRenderType(GetAllTyped(RenderTypes.INPUT), ['bookedCustomerRenderType'], RenderTypes.FORMATTER),
  'CarOwnerPhone': SetRenderType(GetAllTyped(RenderTypes.INPUT), ['bookedCustomerRenderType'], RenderTypes.FORMATTER),
  'InsuranceDamageNr': SetRenderType(GetAllTyped(RenderTypes.INPUT), ['bookedCustomerRenderType'], RenderTypes.FORMATTER),
  'DistanceDriven': SetRenderType(GetAllTyped(RenderTypes.INPUT), ['bookedCustomerRenderType'], RenderTypes.FORMATTER),
  'ChassisNumber': SetRenderType(GetAllTyped(RenderTypes.INPUT), ['bookedCustomerRenderType'], RenderTypes.FORMATTER),
  'Color': GetAllTyped(RenderTypes.INPUT),
  'ColorCode': GetAllTyped(RenderTypes.INPUT),
  'ColorControlIncluded': SetRenderType(GetAllTyped(RenderTypes.CHECKBOX), ['bookedCustomerRenderType'], RenderTypes.FORMATTER),
  'Contact': SetRenderType(GetAllTyped(RenderTypes.INPUT), ['bookedCustomerRenderType'], RenderTypes.FORMATTER),
  'ContactPhone': SetRenderType(GetAllTyped(RenderTypes.INPUT), ['bookedCustomerRenderType'], RenderTypes.FORMATTER),
  'CreationDate': GetAllTyped(RenderTypes.FORMATTER),
  'Delivery': SetRenderType(GetAllTyped(RenderTypes.DATETIME), ['bookedCustomerRenderType'], RenderTypes.FORMATTER),
  'Doors': SetRenderType(GetAllTyped(RenderTypes.SELECTLIST), ['bookedCustomerRenderType'], RenderTypes.FORMATTER),
  'HasRequestedCarRental': GetAllTyped(RenderTypes.CHECKBOX),
  'HasSpareParts': SetRenderType(GetAllTyped(RenderTypes.CHECKBOX), ['bookedCustomerRenderType'], RenderTypes.FORMATTER),
  'IsPaintOrder': SetRenderType(GetAllTyped(RenderTypes.CHECKBOX), ['bookedCustomerRenderType'], RenderTypes.FORMATTER),
  'LoosePartsType': SetRenderType(GetAllTyped(RenderTypes.RADIOLIST), ['bookedCustomerRenderType'], RenderTypes.FORMATTER),
  'Model': SetRenderType(GetAllTyped(RenderTypes.INPUT), ['bookedCustomerRenderType'], RenderTypes.FORMATTER),
  'Pickup': SetRenderType(GetAllTyped(RenderTypes.DATETIME), ['bookedCustomerRenderType'], RenderTypes.FORMATTER),
  'PublishDate': SetRenderTypeBooked(GetBlank(), RenderTypes.FORMATTER),
  'RegistrationDate': SetRenderType(GetAllTyped(RenderTypes.INPUT), ['bookedCustomerRenderType'], RenderTypes.FORMATTER),
  'RegNumber': SetRenderType(GetAllTyped(RenderTypes.INPUT), ['bookedCustomerRenderType'], RenderTypes.FORMATTER),
  'RekvNumber': GetAllTyped(RenderTypes.INPUT),
  'Transport': GetAllTyped(RenderTypes.RADIOLIST), // SetRenderType(GetAllTyped(RenderTypes.RADIOLIST), ['bookedCustomerRenderType'], RenderTypes.FORMATTER),

  // Invisible to customer:
  'BodyShopDeliveryAltLocationComment': GetShopTyped(RenderTypes.TEXTAREA),
  'BodyShopPickupAltLocationComment': GetShopTyped(RenderTypes.TEXTAREA),
  'BodyShopProductionTime': GetShopTyped(RenderTypes.DATETIME),
  'BodyShopRekvNumber': GetShopTyped(RenderTypes.INPUT),
  'BodyShopSelectedStatus': GetShopTyped(RenderTypes.SELECTLIST),
  'CarRentalId': GetShopTyped(RenderTypes.SELECTLIST2),
  'ColorAmount': GetShopTyped(RenderTypes.INPUT),
  'ColorIsReady': GetShopTyped(RenderTypes.CHECKBOX),
  'ColorVariant': GetShopTyped(RenderTypes.INPUT),
  'CustomerName': GetShopTyped(RenderTypes.FORMATTER),
  'DeliveryAltLocationComment': GetShopTyped(RenderTypes.TEXTAREA),
  'DeliveryAltLocationId': GetShopTyped(RenderTypes.SELECTLIST),
  'HasBodyShopDeliveryAltLocation': GetShopTyped(RenderTypes.CHECKBOX),
  'HasBodyShopPickupAltLocation': GetShopTyped(RenderTypes.CHECKBOX),
  'HasDeliveryAltLocation': GetShopTyped(RenderTypes.CHECKBOX),
  'HasPickupAltLocation': GetShopTyped(RenderTypes.CHECKBOX),
  'IsBodyShopOrder': GetShopTyped(RenderTypes.CHECKBOX),
  'LTW': GetShopTyped(RenderTypes.CHECKBOX),
  'LTWIdCode': GetShopTyped(RenderTypes.INPUT),
  'PickupAltLocationComment': GetShopTyped(RenderTypes.TEXTAREA),
  'PickupAltLocationId': GetShopTyped(RenderTypes.SELECTLIST),
  'ProductionDate': GetShopTyped(RenderTypes.DATETIME),
  'SuppressSMS': GetShopTyped(RenderTypes.CHECKBOX)
}
export function GetBlank () {
  return {
    draftCustomerRenderType: RenderTypes.NONE,
    draftShopRenderType: RenderTypes.NONE,
    bookedCustomerRenderType: RenderTypes.NONE,
    bookedShopRenderType: RenderTypes.NONE
  }
}
export function GetAllTyped (renderType) {
  return SetRenderTypeAll(GetBlank(), renderType)
}
export function GetShopTyped (renderType) {
  return SetRenderTypeShop(GetBlank(), renderType)
}
export function GetConfig (name) {
  // console.log('[GetConfig]', name)
  let config = RenderConfig[name]
  if (typeof config === 'undefined') {
    config = GetBlank()
    console.error('[GetConfig] Missing config for name, inserting Blank config - ', name)
  }
  return config
}

export function SetRenderType (types, propNames, renderType) {
  let newTypes = Object.assign({}, types)
  propNames.map((value) => {
    newTypes[value] = renderType
  })
  return newTypes
}
export function SetRenderTypeBooked (types, renderType) {
  return SetRenderType(types, ['bookedShopRenderType', 'bookedCustomerRenderType'], renderType)
}
export function SetRenderTypeAll (types, renderType) {
  return SetRenderType(types, ['draftCustomerRenderType', 'bookedCustomerRenderType', 'draftShopRenderType', 'bookedShopRenderType'], renderType)
}
export function SetRenderTypeCustomer (types, renderType) {
  return SetRenderType(types, ['draftCustomerRenderType', 'bookedCustomerRenderType'], renderType)
}
export function SetRenderTypeShop (types, renderType) {
  return SetRenderType(types, ['draftShopRenderType', 'bookedShopRenderType'], renderType)
}



// WEBPACK FOOTER //
// ./src/app/pages/Orders/Order/NewWorkCard/configuration.js